import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list", "addButton"]
  static values = { contactId: Number }

  connect() {
    this.updateButtonState()
  }

  disconnect() {
    // Cleanup
  }

  async add(event) {
    event.preventDefault()

    const email = this.inputTarget.value.trim().toLowerCase()

    if (!this.isValidEmail(email)) {
      this.showError("Veuillez entrer une adresse email valide")
      return
    }

    this.setLoading(true)

    try {
      const response = await fetch(`/admin/contacts/${this.contactIdValue}/additional_emails`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.getCSRFToken()
        },
        body: JSON.stringify({ email })
      })

      const data = await response.json()

      if (response.ok) {
        this.addEmailToList(email)
        this.inputTarget.value = ""
        this.showSuccess("Email ajouté")
      } else {
        this.showError(data.error || "Erreur lors de l'ajout")
      }
    } catch {
      this.showError("Erreur de connexion")
    } finally {
      this.setLoading(false)
    }
  }

  async remove(event) {
    event.preventDefault()

    const email = event.currentTarget.dataset.email

    if (!confirm(`Supprimer l'email ${email} ?`)) {
      return
    }

    try {
      const response = await fetch(`/admin/contacts/${this.contactIdValue}/additional_emails`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.getCSRFToken()
        },
        body: JSON.stringify({ email })
      })

      if (response.ok) {
        this.removeEmailFromList(email)
        this.showSuccess("Email supprimé")
      } else {
        const data = await response.json()
        this.showError(data.error || "Erreur lors de la suppression")
      }
    } catch {
      this.showError("Erreur de connexion")
    }
  }

  addEmailToList(email) {
    const emailItem = document.createElement("div")
    emailItem.className = "flex items-center gap-2 px-3 py-2 bg-gray-50 rounded-lg group"
    emailItem.innerHTML = `
      <i class="fa-solid fa-envelope text-gray-400 text-sm"></i>
      <span class="flex-1 text-sm text-gray-700">${this.escapeHtml(email)}</span>
      <button type="button" class="text-gray-400 hover:text-red-500 transition-colors opacity-0 group-hover:opacity-100" data-action="click->additional-emails#remove" data-email="${this.escapeHtml(email)}" title="Supprimer cet email">
        <i class="fa-solid fa-times"></i>
      </button>
    `
    this.listTarget.appendChild(emailItem)
  }

  removeEmailFromList(email) {
    const items = this.listTarget.querySelectorAll("[data-email]")
    items.forEach(button => {
      if (button.dataset.email === email) {
        button.closest(".flex").remove()
      }
    })
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  updateButtonState() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("input", () => {
        this.addButtonTarget.disabled = !this.inputTarget.value.trim()
      })
    }
  }

  setLoading(loading) {
    if (this.hasAddButtonTarget) {
      this.addButtonTarget.disabled = loading
      if (loading) {
        this.addButtonTarget.innerHTML = '<i class="fa-solid fa-spinner fa-spin mr-1"></i> Ajout...'
      } else {
        this.addButtonTarget.innerHTML = '<i class="fa-solid fa-plus mr-1"></i> Ajouter'
      }
    }
  }

  showError(message) {
    // Simple flash message
    this.showFlash(message, "error")
  }

  showSuccess(message) {
    this.showFlash(message, "success")
  }

  showFlash(message, type) {
    const flash = document.createElement("div")
    flash.className = `fixed bottom-4 right-4 px-4 py-2 rounded-lg text-white text-sm z-50 transition-opacity duration-300 ${type === "error" ? "bg-red-500" : "bg-green-500"}`
    flash.textContent = message
    document.body.appendChild(flash)

    setTimeout(() => {
      flash.style.opacity = "0"
      setTimeout(() => flash.remove(), 300)
    }, 3000)
  }

  getCSRFToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
